module.exports = __webpack_public_path__ + "img/pickthree.09b5d689.png";